module.exports = __webpack_public_path__ + "assets/img/solution5.da0797f8.png";